<template>
  <topics-table :view="view"/>
</template>

<script>
import { mapState } from 'vuex'
import topicsTable from './table'

export default {
  components: {
    topicsTable
  },
  computed: {
    ...mapState('tenants', {
      view: '_defaultView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/topics/all.vue